import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { useUpdatePendingKgMutation } from "./sortingApi";
import toast from "react-hot-toast";

const UpdatePendingKgModal = ({ show, setShow, currentKg }) => {
  const { _t } = useTranslator();
  const [updatePendingKg, { isLoading }] = useUpdatePendingKgMutation();
  const [kg, setKg] = useState(currentKg || "");

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isLoading) return;

    const numericKg = parseFloat(kg);
    
    if (isNaN(numericKg) || numericKg < 0) {
      toast.error(_t("please_enter_valid_kg", "Please enter a valid weight in kg."));
      return;
    }

    try {
      await updatePendingKg({ new_pending_weight: numericKg }).unwrap();
      // toast.success(_t("kg_updated_successfully", "KG updated successfully"));
      handleClose();
    } catch (error) {
      console.error("Error updating pending KG:", error);
      // toast.error(_t("error_updating_kg", "Error updating KG"));
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("update_pending_kg", "Update Pending KG")}
    >
      <Row>
        <Col lg={12}>
          <InputWithLabel
            label={_t("pending_kg", "Pending KG")}
            type="number"
            name="kg"
            value={kg}
            onChange={(e) => setKg(e.target.value)}
            placeholder={"0"}
            step="0.01"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-end mt-3">
          <Button
            label={_t("update", "Update")}
            size="small"
            onClick={handleSubmit}
            disabled={isLoading}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default UpdatePendingKgModal;
